var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMembersXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 60,
    viewBox: "0 0 76 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 58.636C24.3364 58.636 18.7999 56.9565 14.0906 53.8099C9.38141 50.6633 5.71101 46.1909 3.5436 40.9583C1.37618 35.7257 0.809082 29.9679 1.91402 24.413C3.01896 18.8581 5.74631 13.7556 9.75118 9.75069C13.756 5.74582 18.8586 3.01847 24.4135 1.91353C29.9684 0.808593 35.7262 1.37569 40.9588 3.54311C46.1914 5.71053 50.6638 9.38092 53.8104 14.0901C56.957 18.7994 58.6365 24.3359 58.6365 29.9997C58.6365 37.5945 55.6195 44.8783 50.2491 50.2486C44.8787 55.619 37.595 58.636 30.0001 58.636V58.636Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9366 1.54603C36.0142 1.42451 37.0977 1.36351 38.1821 1.3633C45.468 1.35536 52.4829 4.1249 57.7984 9.10789C63.1138 14.0909 66.33 20.9126 66.792 28.1838C67.254 35.4551 64.927 42.629 60.285 48.2446C55.6429 53.8603 49.0349 57.4954 41.8066 58.4097C39.3376 58.7195 36.839 58.7112 34.3721 58.3851",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3575 1.54603C43.4351 1.42451 44.5186 1.36351 45.603 1.3633C52.8889 1.35536 59.9038 4.1249 65.2193 9.10789C70.5347 14.0909 73.7509 20.9126 74.2129 28.1838C74.6749 35.4551 72.3479 42.629 67.7059 48.2446C63.0638 53.8603 56.4558 57.4954 49.2275 58.4097C46.7585 58.7195 44.2599 58.7112 41.793 58.3851",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2726 26.2008C39.2732 27.9861 38.744 29.7316 37.752 31.216C36.76 32.7005 35.3499 33.8572 33.7002 34.5398C32.0504 35.2225 30.2352 35.4002 28.4844 35.0507C26.7336 34.7011 25.1258 33.8399 23.8647 32.5761C22.6036 31.3123 21.7458 29.7027 21.3999 27.9511C21.054 26.1996 21.2357 24.3848 21.9218 22.7365C22.6079 21.0882 23.7676 19.6805 25.2542 18.6917C26.7407 17.7029 28.4873 17.1773 30.2726 17.1817C32.6609 17.1882 34.9492 18.1411 36.6362 19.8316C38.3231 21.5222 39.2712 23.8125 39.2726 26.2008V26.2008Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.273 54.853C42.1669 51.6706 40.8281 48.6541 38.5394 46.4404C36.2507 44.2268 33.1912 42.9893 30.0071 42.9893C26.823 42.9893 23.7635 44.2268 21.4748 46.4404C19.1861 48.6541 17.8473 51.6706 17.7412 54.853",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersXl);
export default __webpack_public_path__ + "static/media/membersXL.a5c45f845ff32feb35cf8cb49546fed2.svg";
export { ForwardRef as ReactComponent };